import { render, staticRenderFns } from "./message.html?vue&type=template&id=cf55a13a&scoped=true&"
import script from "./message.js?vue&type=script&lang=js&"
export * from "./message.js?vue&type=script&lang=js&"
import style0 from "./message.sass?vue&type=style&index=0&id=cf55a13a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf55a13a",
  null
  
)

component.options.__file = "message.vue"
export default component.exports